import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";
import { SubscriptionResource } from "@/interfaces";

export function usePaymentSubscriptions(
  contractId?: number | string,
  subscriptionId?: number | string
) {
  return useQuery<SubscriptionResource>({
    queryKey: [
      "payment-subscriptions",
      Number(contractId),
      Number(subscriptionId),
    ],
    queryFn: async () => {
      if (!contractId || !subscriptionId) return [];

      const res = await axiosInstance().get(
        `/folloportal/contracts/${contractId}/subscriptions/${subscriptionId}/schedule`
      );

      return res.data.data;
    },
    enabled: !!contractId && !!subscriptionId,
    staleTime: 0,
  });
}
